import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// Schema
import MainApiService from "../../../../../services/mainApi.service";
import {
  AutoComplete,
  AutoCompleteMulti,
  FilePicker,
  FormContainer,
  useFetch,
} from "@4uhub/lib4uhub";
import { DownloadModelButton } from "../DownloadModelButton/DownloadModelButton";
import { ListImportBatchService } from "../../../../../services/listImportBatch.service";
import { listFileSchema, TListFileForm } from "./listFileSchema";
import { listClassificationsByProfileAccess } from "../../../../../services/listProfileAccess.service";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";

const genericService = new MainApiService(GENERICS_ROUTE);

const listImportBatchService = new ListImportBatchService();

const translationPath = "page.4uDlist.listFiles.";

const ListFile = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    listImportBatchService.uploadExcel,
  );

  const saveHandler = (v: TListFileForm) =>
    save({
      file: v.file,
      listClassificationId: v.listClassification.id,
      porpouseIds: v.purposes.map((item) => item.id),
      integrationTypeId: v.integrationType ? v.integrationType.id : undefined,
    });

  const loading = sLoading;

  return (
    <FormContainer<TListFileForm>
      saveFunction={saveHandler}
      loading={loading}
      title={t(translationPath + "list_file")}
      schema={listFileSchema}
      subtitle={t(translationPath + "new")}
      fields={() => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <DownloadModelButton />
          </Grid>

          <Grid item xs={12} sm={12}>
            <AutoCompleteMulti
              params={{ Identifier: "ListImportPorpouses" }}
              name="purposes"
              label={t(translationPath + "purposes")}
              getOptionLabel={(option) => option.name}
              size="small"
              fullWidth
              request={genericService.list}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AutoComplete
              params={{ Identifier: "UserIntegrationType" }}
              name="integrationType"
              label={t(translationPath + "integration_type")}
              getOptionLabel={(option) => option.name}
              size="small"
              fullWidth
              request={genericService.list}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AutoComplete
              name="listClassification"
              label={t(translationPath + "list_classification")}
              getOptionLabel={(option) => option.name}
              size="small"
              fullWidth
              request={listClassificationsByProfileAccess}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FilePicker
              name="file"
              label={`${t(translationPath + "file")}`}
              accept="vnd.ms-excel, vnd.openxmlformats-officedocument.spreadsheetml.sheet" //Formatos .xls e .xlsx, respectivamente
              maxSize={18}
            />

            <Typography variant="caption" color="text.secondary" sx={{ mx: 3 }}>
              {t(translationPath + "file_caption")}
            </Typography>
          </Grid>
        </Grid>
      )}
    />
  );
};

export default ListFile;
